export enum Feature {
  Statistics = 'Statistics',
  Fleet = 'Fleet',
  Standby = 'Standby',
  Trips = 'Trips',
  POI = 'POI',
  Users = 'Users',
  Reports = 'Reports',
  Emissions = 'Emissions',
  Vehicles = 'Vehicles',
  Assets = 'Assets',
  DamageReport = 'DamageReport',
}
